// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__uPS9i","l3":"loader_l3__eMv2X"};